// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__5uvF+","ActionBox":"styles_ActionBox__1phMe"};